export default __webpack_public_path__ + "static/media/foreground2.21853083.png";